import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_GENERAL_SETTINGS_ROUTE_NAME } from '@modules/general-settings/constants';
import {
  ADMIN_GENERAL_SETTINGS_UPLOAD_LOGO_PERMISSIONS,
  ADMIN_GENERAL_SETTINGS_UPLOAD_LOGO_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS_UPLOAD_LOGO,
} from '@modules/general-settings/submodules/upload-logo/constants';
import { useI18n } from '@modules/i18n/composables';

import { getTranslationKeys } from './translations';

export class AdminGeneralSettingsUploadLogoModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_UPLOAD_LOGO_ROUTE_NAME,
      path: 'upload_logo',

      component: () => import('@modules/general-settings/submodules/upload-logo/pages/AdminGeneralSettingsUploadLogoPage/AdminGeneralSettingsUploadLogoPage.vue'),

      permission: ADMIN_GENERAL_SETTINGS_UPLOAD_LOGO_PERMISSIONS.PROJECTSETTINGS_EDIT,
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      caption: getTPath(TRANSLATION_GROUP_GENERAL_SETTINGS_UPLOAD_LOGO, 'TAB_NAME'),
      to: {
        name: ADMIN_GENERAL_SETTINGS_UPLOAD_LOGO_ROUTE_NAME,
      },
      permission: ADMIN_GENERAL_SETTINGS_UPLOAD_LOGO_PERMISSIONS.PROJECTSETTINGS_EDIT,
      id: ADMIN_GENERAL_SETTINGS_UPLOAD_LOGO_ROUTE_NAME,
      order: 110,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS_UPLOAD_LOGO, getTranslationKeys);
  }
}
